import Phaser from "phaser";

export class CounterAttackSystem {
  gauge = 0;
  activeUntil = 0;
  chargeLevel = 0;
  private passiveAccumulator = 0;

  constructor(private readonly scene: Phaser.Scene) {}

  get chargeUpgradeCost() {
    return this.chargeLevel >= 6 ? Infinity : 95 + this.chargeLevel * 70;
  }

  add(amount: number) {
    this.gauge = Math.min(100, this.gauge + amount * (1 + this.chargeLevel * 0.14));
  }

  canActivate() {
    return this.gauge >= 100;
  }

  activate() {
    if (!this.canActivate()) return false;
    this.gauge = 0;
    this.activeUntil = this.scene.time.now + 16000;
    return true;
  }

  upgradeCharge(spend: (cost: number) => boolean) {
    const cost = this.chargeUpgradeCost;
    if (!Number.isFinite(cost) || !spend(cost)) return false;
    this.chargeLevel += 1;
    this.add(8 + this.chargeLevel * 2);
    return true;
  }

  update(time: number, deltaMs = 0) {
    if (this.activeUntil > 0 && time > this.activeUntil) {
      this.activeUntil = 0;
    }
    if (this.chargeLevel <= 0 || this.gauge >= 100 || deltaMs <= 0) return;
    this.passiveAccumulator += deltaMs;
    while (this.passiveAccumulator >= 1000) {
      this.gauge = Math.min(100, this.gauge + 0.35 + this.chargeLevel * 0.28);
      this.passiveAccumulator -= 1000;
    }
  }

  get active() {
    return this.scene.time.now < this.activeUntil;
  }
}
